<template>
    <div class="agent-manage" v-wechat-title="title">
        <div class="container" v-if="showPage">

            <div class="patient_list">
                <van-radio-group v-model="radio">
                    <van-cell v-for="item,index in list" :key="index"  @click="radio = item.id">
                        <template #icon>
                            <van-radio :name="item.id" checked-color="#0AA8AF" />
                        </template>
                        <template #title >
                            <div class="patient_info">
                                <div class="avatar flex-center-col">
                                    <van-image v-if="!item.idsn_pic" round  width="6rem" height="6rem" src="/static/user_avatar.jpg" />
                                    <van-image v-else round  width="6rem" height="6rem" :src="item.idsn_pic.indexOf('http')>=0?item.idsn_pic:baseUrl+item.idsn_pic" />
                                </div>
                                <div class="flex-center-col">
                                    <div class="flex-center-row">
                                        <div style="margin-right:10px;" >{{item.name}}</div>
                                        <van-icon  size="2rem" name="delete-o" @click="deleteAgent(item)" />
                                    </div>
                                    <div>{{item.idsn.substring(0,6)}}****{{item.idsn.substring(10,18)}}</div>
                                </div>
                            </div>
                        </template>
                        <template>
                            <div class="btn-contain" @click="addAgent(item)"> <van-icon name="arrow"  /> </div>
                        </template>
                    </van-cell>
                </van-radio-group>
                <div class="btn">
                    <van-button type="default" class="btn1" plain round @click="addAgent()" :disabled="disabled" color="#0AA8AF" size="small" style="margin:0 10vw;font-size:14px;">
                        新增代领药人</van-button>
                </div>
            </div>

            <div class="btn">
                <van-button type="default" class="btn1" plain round @click="$router.go(-1)" color="#0AA8AF" :disabled="disabled">
                返回</van-button>
                <van-button type="default" class="btn2" round @click="setAgent" color="#0AA8AF" :disabled="disabled" >
                确认</van-button>
            </div>
 
        </div>
    </div>
</template>
<script>
import { getFamilys,deleteFamily,setFamily } from '@/api/patient'
import { Toast,Divider,Dialog } from 'vant'
import Vue from "vue";
import { mapState } from "vuex";
Vue.use(Toast)
Vue.use(Divider);
Vue.use(Dialog);


export default {
    name:"agentManage",
    data(){
        return {
            title:'代领药人管理',
            showPage:true,//切换显示页面1
            papid:'',
            list: [],
            radio:'',

            disabled:false,
            baseUrl:'http://zmtx.papv2.sungotech.com',


        }
    },
    computed: {
        ...mapState(['patientOne', 'userInfo','patientInfo']),
    },
    async created(){
        Toast.loading({ duration: 0,  forbidClick: true });

        this.papid=this.patientOne.papid;
        await this.getData();

        Toast.clear()
    },
    methods: {
        async getData(){
            await getFamilys({
                papid:this.papid
            }).then(res=>{
                if(res.data){
                    console.log("getFamilys",res.data)
                    this.list=res.data
                }
            })
        },
        async deleteAgent(item){
            this.disabled=true;
            Dialog.confirm({
                message: '确认要删除该代领药人吗？',
                confirmButtonColor:'#0AA8AF',
            })
            .then(() => {
                
                deleteFamily({papid: this.papid,family_id:item.id}).then(res=>{
                    this.$router.go(0)
                }).catch(err => {
                    Toast.fail('删除失败');
                })
                
            })
            .catch(() => {
                // on cancel
            });
            this.disabled=false;
        },
        addAgent(item){
            this.$router.push({name:"AddAgent",query:{idsn:item?item.idsn:''}})
        },
        async setAgent(){//设置本阶段代领药人
            if(!this.radio){
                Toast('请选择代领药人')
                return
            }
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true
            });
            await setFamily({ papid: this.papid, family_id:this.radio }).then(res=>{
                if(res.data){
                    this.$router.push({name:'AgentUpload'})
                }
            }).catch(err => {
                Toast.fail('设置代领药人失败');
                Toast.clear()
            })
            Toast.clear()
        },
    },
}

</script>
<style lang="less" scoped>
.agent-manage{
    min-height:100vh;
    .container{
        min-height:100vh;
        display: flex;
        flex-flow: column wrap;
        justify-content:space-between;
        .group2{
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            .van-cell__value{
                // flex:2 0 !important;
            }
            ::v-deep .van-cell__title{
                max-width: 100px!important;
            }
            
        }
        .contain-cell{
            // box-shadow: 0 0 8px  rgba(0, 0, 0, 0.15);
            box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
            border-radius: 8px;
            display: flex;
            flex-flow: column nowrap;
            justify-content:center;
            align-items:center;
            margin: 20px 16px 10px 16px;
            .van-cell{
                border-radius: 8px;
            }
            .timer{
                &::after{
                    border-bottom:none !important;
                }
                .van-cell__value{
                    flex:1 0;
                }
                .van-cell__title{
                    flex:2 0;
                }
            }
        }
        .patient_list{
            margin-top: 18px;
            padding-bottom: 44px;
            .van-cell{
                display: flex;
                justify-content: center;
                align-items: center;
                // .van-cell__title{
                // }
                .van-cell__value{
                    height:100%;
                    .btn-contain{
                        height:100%;
                    }
                }
            }
            .patient_info{
                display: flex;
                .flex-center-col{
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: center;
                    align-items: flex-start;
                }
                .flex-center-row{
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    align-items: center;
                }
                .avatar{
                    margin:0 10px;
                }
            }
            .add_btn{
                position:fixed;
                bottom:0;
                width:100%;
            }
            
            }
    }
    .popup{
        min-height:100vh;
        .contract-box {
            position: relative;
            height: 100%;
            display: flex;
            flex-direction: column;

            .contract-title {
                background: #fff;
                box-sizing: content-box;
                width: auto;
                line-height: 24px;
                height: 24px;
                font-size: 1.6rem;
                text-align: center;
                padding: 20px 50px 10px;
                background: #fff;
            }

            .contract-text {
                // margin-bottom: 20px;
                flex: 1;
                // height: 50%;
                font-size: 1.4rem;
                text-align: justify;
                // text-align-last: left;
                line-height: 1.5;
                height: 100%;
                padding: 15px;
                overflow-y: auto;
                transition: transform .3s;
                -webkit-overflow-scrolling: touch;
                padding-bottom: 160px;
            }
        }
    }
    .btn-group{
        display: flex;
        padding: 16px;
        button{
            width: 100%;
        }
    }
    .flex-col{
        display: flex;
        flex-flow: column nowrap;
        button{
            margin-bottom: 10px;
        }
    }


    .btn{
      display: flex;
      justify-content:space-between;
      width: 100%;
      padding: 10px;
      // background-color: white;
      margin: 0;
      .van-button{
        margin: 0 5px;
        white-space: nowrap;
      }
      .btn1{flex-grow: 1;}
      .btn2{flex-grow: 4;}
    }
}
</style>